import React from 'react';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import {
  Box,
  IconButton,
  TableCell,
  TableRow,
  withStyles,
} from '@material-ui/core';
import classNames from 'classnames';
import styles from './styles';
import PropTypes from 'prop-types';

function TemplateGroupRow(props) {
  const {
    content,
    color,
    selected,
    onClick,
    toggle,
    isCollapsed,
    classes,
    columnConfigs,
  } = props;

  return (
    <TableRow
      className={classNames(classes.tableRow, 'cursorPointer')}
      hover
      onClick={onClick}
      selected={selected}
    >
      <TableCell
        colSpan={columnConfigs.length - 1}
        style={{ boxShadow: `inset 10px 0px 0px 0px ${color}` }}
      >
        <Box sx={{ display: 'flex', gap: 3 }}>{content}</Box>
      </TableCell>
      <TableCell>
        <IconButton onClick={toggle} size="small">
          {isCollapsed ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
        </IconButton>
      </TableCell>
    </TableRow>
  );
}

TemplateGroupRow.propTypes = {
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  isCollapsed: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  columnConfigs: PropTypes.array.isRequired,
  content: PropTypes.node.isRequired,
  color: PropTypes.string,
};

export default withStyles(styles)(TemplateGroupRow);
